let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1zfue")).then(() => parcelRequire('4ABXT'));